import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500; // 개발자가 수동으로 계산한 높이
const TEL_CUSTOMER_CENTER = '02-000-000';

function AuthenticationCountExceededBottomSheetPage() {
  const {t} = useInferableTranslation();
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <div className="bottom_sheet">
        <div className="bottom_sheet_header">
          <h2
            id="bottomSheetTitle"
            className="bottom_sheet_title"
          >
            {t('T30524')}
          </h2>
          <button
            type="button"
            className="btn btn_ic"
            aria-label="close"
          >
            <span
              className="ic ic_close_20px"
              aria-hidden="true"
            ></span>
          </button>
        </div>
        <div className="bottom_sheet_inner">
          <div className="bottom_sheet_contents">
            <strong className="bottom_sheet_title_sub">{t('T30525_$tel', {tel: TEL_CUSTOMER_CENTER})}</strong>
          </div>

          <div className="bottom_sheet_footer">
            <button
              type="button"
              className="btn btn_large btn_filled"
              onClick={() => window.bottomSheetClose(null)}
            >
              {t('T10233')}
            </button>
          </div>
        </div>
      </div>
    </BottomSheetWebViewWrapper>
  );
}

export default AuthenticationCountExceededBottomSheetPage;
